import * as React from "react";
import defaultTheme from "../../defaultTheme";
export const ThemeContext = /*#__PURE__*/React.createContext(defaultTheme);
const ThemeProvider = ({
  children,
  theme
}) => {
  return /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: theme
  }, children);
};
export default ThemeProvider;